export default {"betTypeLabel":"Y2nak","icon":"uI3Cu","diamond":"sVZ-y","hot":"O3aP9"};